import { render, staticRenderFns } from "./FormInputScadenzarioWidget.vue?vue&type=template&id=1612db3d&"
import script from "./FormInputScadenzarioWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputScadenzarioWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports